import { render, staticRenderFns } from "./CallFeeOverview.vue?vue&type=template&id=1e660cc2"
import script from "./CallFeeOverview.vue?vue&type=script&lang=js"
export * from "./CallFeeOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports